import React, {useState} from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart } from '../../components/AppComponents';
import { figure51 } from '../../graphs/ar/figure51';
import Modal from '../../components/Modal';

const Sdg10 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="10" 
                poster={require('../../images/poster-sdg-10.png').default}
                video={require('../../images/video-sdg-10.mp4').default}
                sdgImage={require('../../images/EN_10.svg').default}
                sdg="الهدف 10 من أهداف التنمية المستدامة"
                title="الحد من انعدام المساواة"
                subtitle="الحد من انعدام المساواة داخل البلدان وفيما بينها"
                indicators={['10.a.1']}  
                indicatorsTitle="المؤشرات"
            />

           <Container>
                <TitleSub title="نظرة عامة" />
<p>عكس جائحة كوفيد-19 اتجاه العقود الأخيرة المتمثل في تضييق فجوة عدم المساواة في الدخل العالمي. يهدد التعافي غير المتكافئ في مناطق مختلفة من العالم بزيادة تفاقم عدم المساواة العالمية.</p>
<p>أولئك الذين لديهم دخل منخفض نسبيًا معرضون لخطر التخلف أكثر. كما أدى الوباء إلى تكثيف التمييز الهيكلي والنظامي. تشهد الأسواق الناشئة والاقتصادات النامية انتعاشًا بطيئًا، مما يؤدي إلى اتساع الفوارق في الدخل بين البلدان. وبالتالي، يتطلب تحقيق الهدف 10 من أهداف التنمية المستدامة بذل جهود متضافرة وعاجلة لمعالجة الأسباب الجذرية لعدم المساواة داخل البلدان وفيما بينها.</p>
 <div id="section10.a.1">
                  <HeaderSdg 
                      title="مؤشر أهداف التنمية المستدامة 10 .أ .1"
                        subtitle={["نسبة خطوط التعريفة المطبقة على الواردات من أقل البلدان نمواً والبلدان النامية ذات التعريفة الصفرية", <sup>6</sup>]}
                      target={{
                          sdg: "10",
                          title: 'الغاية 10',
                          text: 'تنفيذ مبدأ المعاملة الخاصة والتفضيلية للبلدان النامية، ولا سيما أقل البلدان نمواً، وفقاً لاتفاقات منظمة التجارة العالمية.'
                      }}
                  />
                </div>

<p><i>تحسن وصول صادرات البلدان النامية وأقل البلدان نمواً إلى الأسواق الدولية دون رسوم جمركية في السنوات الأخيرة، لا سيما بالنسبة للمنتجات الزراعية. ومع ذلك، لا يزال النمو الإجمالي لصادرات أقل البلدان نمواً منخفضاً بشكل مثير للقلق.</i></p>
<p>تسعى الغاية 10 .أ من أهداف التنمية المستدامة لخطة عام 2030 إلى تحسين شروط الوصول إلى الأسواق للصادرات من البلدان النامية وأقل البلدان نمواً من خلال منحها معاملة خاصة وتفضيلية وفقاً لاتفاقيات منظمة التجارة العالمية. يوضح مؤشر أهداف التنمية المستدامة 10.a.1 مدى تطبيق المعاملة الخاصة والتفضيلية في تعريفات الاستيراد، ويتم حسابها كنسبة من خطوط التعريفة الجمركية الصفرية للواردات من أقل البلدان نمواً والبلدان النامية. يوضح المؤشر بشكل فعال إلى أي مدى تتمتع البلدان النامية وأقل البلدان نمواً بحرية الوصول إلى أسواق البلدان المتقدمة.</p>
<p>كما هو موضح في الشكل 51، تتمتع البلدان النامية وأقل البلدان نمواً إما بإمكانية الوصول الكامل أو شبه الكامل إلى معظم الأسواق الدولية دون رسوم جمركية ودون حصص. بين عامي 2015 و2021، ارتفعت نسبة المنتجات التي تصدرها أقل البلدان نمواً والتي يمكن أن تدخل الأسواق الدولية دون رسوم جمركية من 63.8 في المائة إلى 64.1 في المائة. ومع ذلك، كانت هذه الزيادة أكثر أهمية بالنسبة للمنتجات الزراعية على وجه التحديد، من 69 في المائة في عام 2015 إلى 73.6 في المائة في عام 2021.</p>
<p> وفي الوقت نفسه، زادت هذه الحصة بالنسبة للبلدان النامية (من 49.4 إلى 54.6 في المائة) والدول الجزرية الصغيرة النامية (من 62.3 إلى 72.5 في المائة). وخلال الفترة نفسها، ارتفعت نسبة المنتجات الزراعية التي تصدرها البلدان النامية والدول الجزرية الصغيرة النامية والتي يمكن أن تدخل الأسواق الدولية معفاة من الرسوم الجمركية من 50.8 في المائة إلى 55.4 في المائة ومن 62.5 في المائة إلى 73.2 في المائة على التوالي.</p>
<p>وهكذا، كما يشير الشكل 51 أيضًا، كانت المعاملة التفضيلية الممنوحة للصادرات الزراعية من البلدان النامية وأقل البلدان نمواً والبلدان النامية غير الساحلية والدول الجزرية الصغيرة النامية أقل تفضيلاً قليلاً من تلك الممنوحة لأنواع أخرى من الصادرات. ومع ذلك، وعلى الرغم من التحسن منذ عام 2015، فإن مبدأ المعاملة الخاصة والتفضيلية – وهو محرك رئيسي للحد من عدم المساواة العالمية – لا يزال بعيدًا عن التنفيذ الكامل. بالإضافة إلى ذلك، تجدر الإشارة إلى أن التقدم في توسيع الصادرات من أقل البلدان نمواً بطيء. على الرغم من أن صادرات أقل البلدان نمواً قد نمت بشكل كبير منذ عام 2000، إلا أن حصتها في التجارة العالمية الإجمالية ظلت راكدة تقريباً عند 1 في المائة خلال العقد الماضي. وفي الوقت نفسه، ارتفعت حصة أقل البلدان نمواً من سكان العالم من 10.7 في المائة في عام 2000 إلى أكثر من 13.6 في المائة في عام 2020.</p>
</Container>
<ContainerChart
                title="الشكل51. نسبة الصادرات من المناطق ذات مستويات التنمية المختلفة مع عدم وجود رسوم جمركية في الأسواق الدولية (2015 و2021)"
                legend={[
                    {title: '2015', color: '#f3c7db'},
                    {title: '2021', color: '#ff3399'},
                ]}
                note={<span>المصدر: الأمم المتحدة. 2023. قاعدة بيانات مؤشرات أهداف التنمية المستدامة. في: <i>شعبة الإحصاءات في الأمم المتحدة</i>. نيويورك. اقتُبس في 8 يونيو 2023. <a href="https://unstats.un.org/sdgs/dataportal/database">https://unstats.un.org/sdgs/dataportal/database</a>.</span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure51}
                />
</ContainerChart>
<Container>
                <div className="footnotes">
                    <p id="footnote1"><sup>6 </sup>
                          يخضع مؤشر أهداف التنمية المستدامة 10 .أ .1 لتوصيات مركز التجارة الدولية ومؤتمر الأمم المتحدة للتجارة والتنمية ومنظمة التجارة العالمية.
                    </p>
                    <br /><br /><br /><br />
                </div>
            </Container>

        </React.Fragment>
    ) 
}


export default Sdg10;
